import {
  FormControl,
  FormLabel,
  FormErrorMessage,
} from '@chakra-ui/form-control'
import { Input } from '@chakra-ui/input'
import { HStack } from '@chakra-ui/layout'
import type { FormikProps } from 'formik'
import React from 'react'
import { colors } from '../../../../ui-kit'
import type { BackupBucketForm } from '../../../interfaces'

const S3BackupForm = ({
  form: { values, handleChange, errors, touched, handleBlur },
  disabled,
}: {
  form: FormikProps<BackupBucketForm>
  disabled: boolean
}): React.ReactElement => (
  <>
    <HStack spacing="2em" width="100%" alignItems="flex-start">
      <FormControl
        id="bucketName"
        flex="1"
        isRequired
        isInvalid={Boolean(errors.bucketName && touched.bucketName)}
      >
        <FormLabel color={colors.appSlate}>Bucket Name</FormLabel>
        <Input
          disabled={disabled}
          id="bucketName"
          name="bucketName"
          value={values.bucketName}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <FormErrorMessage marginBottom="-2.0408em">
          {errors.bucketName}
        </FormErrorMessage>
      </FormControl>
      <FormControl
        id="bucketPrefix"
        flex="1"
        isRequired
        isInvalid={Boolean(errors.bucketPrefix && touched.bucketPrefix)}
      >
        <FormLabel color={colors.appSlate}>Bucket Folder</FormLabel>
        <Input
          disabled={disabled}
          name="bucketPrefix"
          id="bucketPrefix"
          value={values.bucketPrefix}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <FormErrorMessage marginBottom="-2.0408em">
          {errors.bucketPrefix}
        </FormErrorMessage>
      </FormControl>
    </HStack>

    <HStack spacing="2em" width="100%" alignItems="flex-start">
      <FormControl
        id="credentials.s3AccessKey"
        flex="1"
        isRequired
        isInvalid={Boolean(
          errors.credentials?.s3AccessKey && touched.credentials?.s3AccessKey,
        )}
      >
        <FormLabel color={colors.appSlate}>AWS Access Key</FormLabel>
        <Input
          disabled={disabled}
          id="credentials.s3AccessKey"
          name="credentials.s3AccessKey"
          value={values.credentials.s3AccessKey}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <FormErrorMessage marginBottom="-2.0408em">
          {errors.credentials?.s3AccessKey}
        </FormErrorMessage>
      </FormControl>
      <FormControl
        id="credentials.s3SecretKey"
        flex="1"
        isRequired
        isInvalid={Boolean(
          errors.credentials?.s3SecretKey && touched.credentials?.s3SecretKey,
        )}
      >
        <FormLabel color={colors.appSlate}>AWS Secret Key</FormLabel>
        <Input
          disabled={disabled}
          name="credentials.s3SecretKey"
          value={values.credentials.s3SecretKey}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <FormErrorMessage marginBottom="-2.0408em">
          {errors.credentials?.s3SecretKey}
        </FormErrorMessage>
      </FormControl>
    </HStack>
  </>
)

export default S3BackupForm
